const IconNews = ({ className }) => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' className={className}>
        <path
            d='M5 3H15C16.1 3 17 3.9 17 5H19C20.1 5 21 5.9 21 7V18C21 19.1 20.1 20 19 20H7C5.34 20 4 18.66 4 17V5C4 3.9 4.9 3 6 3Z'
            stroke='white'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M17 7V18C17 18.55 17.45 19 18 19C18.55 19 19 18.55 19 18V7H17Z'
            stroke='white'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path d='M8 8H12' stroke='white' strokeWidth='1.5' strokeLinecap='round' />
        <path d='M8 12H12' stroke='white' strokeWidth='1.5' strokeLinecap='round' />
        <path d='M8 16H12' stroke='white' strokeWidth='1.5' strokeLinecap='round' />
    </svg>
);

export default IconNews;
